import Vue from 'vue'
import enumUtil from './enum'
import enumModules from './mod'

Vue.use(enumUtil, enumModules)
